$shm_projects_page $mol_book2
	project_id \
	pages <= project_pages /
	Menu_page $mol_page
		title_content <= menu_title_rows /
		body /
			<= Menu $mol_view
				sub <= menu_rows /
	Menu_title $mol_string_button
		value? <=> project_title_draft? \
		submit? <=> project_title_commit? null
		event *
			^
			blur? <=> project_title_commit? null
			keydown? <=> project_title_keydown? null
	Project_actions $shm_service_task_menu
		remove_title \Удалить проект
		remove_confirm_title \Удалить проект?
		remove? <=> project_delete? null
	Version_label $mol_text
		text <= version_label \
	Section_link* $mol_link
		arg <= section_arg* *
		title <= section_title* \
		sub / <= section_title* \
	Product_page $mol_page
		title \Продукт
		body /
			<= Product_form $mol_form
				form_fields /
					<= Product_description_field $mol_form_field
						name \Описание
						Content <= Product_description $mol_textarea
							value? <=> product_description? \
					<= Product_problem_field $mol_form_field
						name \Проблема
						Content <= Product_problem $mol_textarea
							value? <=> product_problem? \
					<= Product_audience_field $mol_form_field
						name \Целевая аудитория
						Content <= Product_audience $mol_textarea
							value? <=> product_audience? \
					<= Product_value_field $mol_form_field
						name \Ценность
						Content <= Product_value $mol_textarea
							value? <=> product_value? \
					<= Product_scenarios_field $mol_form_field
						name \Ключевые сценарии
						Content <= Product_scenarios $mol_textarea
							value? <=> product_scenarios? \
					<= Product_success_field $mol_form_field
						name \Критерии успеха
						Content <= Product_success $mol_textarea
							value? <=> product_success? \
					<= Product_stage_field $mol_form_field
						name \Стадия
						Content <= Product_stage $mol_select
							value? <=> product_stage? \idea
							dictionary *
								idea \Идея
								prototype \Прототип
								mvp \MVP
								growing \Развивается
								support \Поддерживается
								archived \Архив
				submit_title \Сохранить
				message_done \Сохранено
				save? <=> product_save? null
	Configuration $shm_projects_configuration
		project_id <= project_id
	Draft_page $mol_page
		title \Черновик
		body /
			<= Draft $mol_textarea
				hint \Черновые заметки проекта
				value? <=> draft_note? \
	Tasks $shm_projects_tasks
		project_id <= project_id
	Sessions $shm_projects_codex_chat
		project_id <= project_id
	Release_stage* $mol_view
		attr *
			status <= release_stage_status* \done
		sub /
			<= Release_stage_marker* $mol_view
			<= Release_stage_title* $mol_view
				sub / <= release_stage_title* \
			<= Release_stage_elapsed* $mol_view
				sub / <= release_stage_elapsed* \
	Docs $shm_projects_docs
		menu_title \Документация
		readme_text <= docs_readme_text \
		agents_text <= docs_agents_text \
	Modules_page $mol_page
		title \Модули
		body /
			<= Modules $mol_list
				rows <= module_rows /
	Module_link* $mol_link
		arg <= module_arg* *
		title <= module_title* \
		sub / <= module_title* \
	Module_empty $mol_view
		sub / \У проекта нет собственных модулей
	Module_page $mol_page
		title <= module_selected_title \
		body /
			<= Module_readme $mol_text
				text <= module_readme_text \
	Dependencies_page $mol_page
		title \Зависимости
		body /
			<= Dependencies $mol_list
				rows <= dependency_rows /
	Dependency_link* $mol_link
		arg <= dependency_arg* *
		title <= dependency_title* \
		sub / <= dependency_title* \
	Dependency_empty $mol_view
		sub / \У проекта нет зависимостей
	Dependency_page $mol_page
		title <= dependency_selected_title \
		body /
			<= Dependency_details $mol_view
				sub /
					<= Dependency_type $mol_view
						sub / \Тип: MAM
					<= Dependency_commits $mol_text
						text <= dependency_commits_text \
					<= Dependency_behind $mol_view
						sub / <= dependency_behind_text \
	Project_tests $shm_projects_tests
		project_id <= project_id
	History_page $mol_page
		title \История версий
		body /
			<= Versions $mol_view
				sub <= version_rows /
	Version_link* $mol_link
		arg <= version_arg* *
		uri_off <= version_uri* \
		current <= version_link_current* false
		title <= version_title* \
		sub / <= version_title* \
	Version_page $mol_page
		title_content /
			<= Version_modes $mol_view
				sub <= version_mode_rows /
		body <= version_content /
	Version_result_mode $mol_link
		arg <= version_result_arg *
		current <= version_result_current false
		title \Результат
		sub / \Результат
	Version_benchmarks_mode $mol_link
		arg <= version_benchmarks_arg *
		current <= version_benchmarks_current false
		title \Бенчмарки
		sub / \Бенчмарки
	Version_changes_mode $mol_link
		arg * project_version_output \changes
		current <= version_changes_current false
		title \Список изменений
		sub / \Список изменений
	Version_changes $shm_projects_release_notes_view
		notes <= version_release_notes null
	Version_session_mode* $mol_link
		arg <= version_session_arg* *
		current <= version_session_current* false
		title <= version_session_title* \
		sub / <= version_session_title* \
	Version_details $mol_view
		sub /
			<= Version_date $mol_text
				text <= version_selected_date \
			<= Version_actions $mol_view
				sub <= version_action_rows /
			<= Version_stages_section $mol_view
				sub <= version_stages_section_rows /
			<= Requirements_section $mol_view
				sub /
					<= Requirements_title $mol_view
						sub / \Требования
					<= Version_requirements $mol_text
						text <= version_selected_requirements \
			<= Changes_section $mol_view
				sub /
					<= Changes_title $mol_view
						sub / \Что изменилось
					<= Changes $mol_list
						rows <= change_rows /
			<= Tests_section $mol_view
				sub /
					<= Tests_title $mol_view
						sub / <= version_tests_title \
					<= Version_tests $mol_list
						rows <= version_test_rows /
			<= Other_artifacts_section $mol_view
				sub /
					<= Other_artifacts_title $mol_view
						sub / \Другие артефакты
					<= Other_artifacts $mol_list
						rows <= other_artifact_rows /
	Version_stages_title $mol_view
		sub / \Этапы пререлиза
	Version_stage_list $mol_list
		rows <= version_stage_rows /
	Version_session $mol_view
		sub <= version_session_rows /
	Version_benchmarks_panel $mol_view
		sub <= version_benchmarks_panel_rows /
	Version_benchmark_chart_section $mol_view
		sub /
			<= Version_benchmark_chart_head $mol_view
				sub /
					<= Version_benchmark_chart_title $mol_view
						sub / \Динамика по версиям
					<= Version_benchmark_lines $mol_pick
						hint \Выбрать линии графика
						trigger_content /
							<= Version_benchmark_lines_icon $mol_icon_chart_line
							<= version_benchmark_lines_title \
						bubble_content /
							<= Version_benchmark_line_select $shm_check_list_only
								options <= version_benchmark_line_ids /
								value? <=> version_benchmark_lines_selected? /
								check_title* <= version_benchmark_line_title* \
			<= Version_benchmark_chart_frame $mol_view
				sub /
					<= Version_benchmark_chart $shm_echarts
						option <= version_benchmark_chart_option *
	Version_benchmark_legend $mol_view
		sub /
			<= Version_benchmark_legend_title $mol_view
				sub / \Что входит в замеры
			<= Version_benchmark_legend_list $mol_list
				rows <= version_benchmark_legend_rows /
	Version_benchmark_file_filters $mol_view
		sub /
			<= Version_benchmark_file_filters_title $mol_view
				sub / <= version_benchmark_dimension_title \Наборы данных
			<= Version_benchmark_files $shm_check_list_only
				inline true
				only_visible false
				options <= version_benchmark_file_ids /
				value? <=> version_benchmark_files_selected? /
				check_title* <= version_benchmark_file_title* \
	Version_benchmark_legend_item* $mol_view
		sub /
			<= Version_benchmark_legend_item_title* $mol_view
				sub / <= version_benchmark_legend_item_title* \
			<= Version_benchmark_legend_item_description* $mol_view
				sub / <= version_benchmark_legend_item_description* \
	Version_benchmark_info $mol_text
		text <= version_benchmark_info \
	Version_benchmark_run $mol_button_major
		title \Прогнать бенчмарки
		click? <=> version_benchmark_run? null
	Version_benchmark_status $mol_text
		text <= version_benchmark_status \
		style *
			^
			color <= version_benchmark_status_color \
	version_session_run null
	version_session_iteration* 0
	version_session_prerelease* false
	Version_session_chat* $shm_projects_goal_chat
		run <= version_session_run
		iteration <= version_session_iteration*
		prerelease <= version_session_prerelease* false
		version <= version_session_version \
	Version_release $mol_button_major
		title \Сделать релиз
		enabled <= release_allowed true
		click? <=> release_make? null
	Version_prerelease $mol_button_major
		title \Сделать пререлизом
		enabled <= prerelease_allowed true
		click? <=> prerelease_activate? null
	Version_release_state $mol_text
		text <= version_release_status \
		style *
			^
			color <= version_release_status_color \
	Change* $mol_view
		sub <= change_content* /
	Change_title* $mol_view
		sub / <= change_title* \
	Change_description* $mol_text
		text <= change_description* \
	Change_screenshots* $mol_view
		sub <= change_screenshot_rows* /
	Change_screenshot* $shm_projects_image_viewer
		uri <= change_screenshot_uri* \
	Version_test* $mol_link
		uri <= version_test_uri* \
		external true
		sub /
			<= Version_test_status* $mol_view
				sub / <= version_test_status* \
				style *
					^
					color <= version_test_status_color* \
			<= Version_test_title* $mol_view
				sub / <= version_test_title* \
	Version_benchmarks $mol_view
		sub /
			<= Version_benchmark_tables $mol_list
				rows <= version_benchmark_rows /
	No_benchmarks $mol_view
		sub / <= no_benchmarks_title \Для этой версии бенчмарки не запускались
	Version_benchmark* $mol_view
		sub /
			<= Version_benchmark_title* $mol_view
				sub / <= version_benchmark_title* \
			<= Version_benchmark_table_scroll* $mol_scroll
				sub /
					<= Version_benchmark_table* $mol_view
						dom_name \table
						sub /
							<= Version_benchmark_table_head* $mol_view
								dom_name \thead
								sub /
									<= Version_benchmark_table_header* $mol_view
										dom_name \tr
										sub <= version_benchmark_table_header_cells* /
							<= Version_benchmark_table_body* $mol_view
								dom_name \tbody
								sub <= version_benchmark_table_body_rows* /
	Version_benchmark_table_header_cell* $mol_view
		dom_name \th
		sub / <= version_benchmark_table_header_cell_text* \
	Version_benchmark_table_row* $mol_view
		dom_name \tr
		sub <= version_benchmark_table_row_cells* /
	Version_benchmark_table_cell* $mol_view
		dom_name \td
		sub /
			<= version_benchmark_table_cell_text* \
			<= Version_benchmark_table_cell_difference* $mol_view
				dom_name \span
				attr *
					^
					benchmark_change <= version_benchmark_table_cell_change* \
				sub / <= version_benchmark_table_cell_difference_text* \
	Other_artifact* $mol_link
		uri <= other_artifact_uri* \
		external true
		title <= other_artifact_title* \
	No_other_artifacts $mol_view
		sub / \Других артефактов нет
